import { Component, OnInit, ViewChild } from '@angular/core';
import { NavModalComponent } from '../../../core/component/NavModal.Component';
import { GuardianinfoService } from '../../forms/school-management/Admission/guardianinfo/guardianinfo.service';
import { SMStudentinfoService } from '../../forms/school-management/transaction/studentprofile/studentprofile.service';
import { GenEnum } from '../../shared/general.enum';
import { ImageService } from '../../shared/image.service';
import { IxsloaderComponent } from '../../../components/ixsloader/ixsloader.component';
import { SMBlockactivityService } from '../../forms/school-management/transaction/blockactivity/blockactivity.service';

@Component({
  selector: "childs",
  templateUrl: './childs.component.html',
})
export class ChildsComponent extends NavModalComponent<any> {



  guardianid: any;
  userObj: any;
  ChildList: any[] = [];
  imageSource: string;
  url: string;
  studid: any;
  studdata: SMStudentinfoService;
  data: any;
  guardiandata: any;
  guardianname: string;
  guardiancontactno: string;
  guardianaddress: string;
  guardianimage: any;
  studentchildlist: boolean = false;
  guardianemail: any;


  @ViewChild(IxsloaderComponent) loader: IxsloaderComponent
  localurl: string;
  guardianlastname: any;

  constructor(

    private guardianService: GuardianinfoService,
    private studentService: SMStudentinfoService,
    private imageService: ImageService,
    private blockactivityservice: SMBlockactivityService
  ) {
    super(guardianService);
  }
  sectionid: any;
  courseid: any;

  async ngOnInit() {
    let user = this.localStorage.get("utuser");
    this.localurl = this.localStorage.get('OnlyUrl');
    this.imageSource = this.localurl + GenEnum.Image.imageUrl;
    this.userObj = JSON.parse(user)
    await this.getstudlist();

    await this.currentguardian(this.userObj.empid, '');


  }

  async getstudlist() {

    this.loader.startLoading();
    await this.studentService.getChildList(this.userObj.empid);

    this.SyncData.setValue({
      key: "Studentlistdata",
      value: this.studentService.ChildList,
    })
    if (this.studentService && this.studentService.ChildList.length && this.studentService.ChildList.length === 1) {
      this.studid = this.studentService.ChildList[0].Id;
      this.localStorage.set("Studentid", this.studid);
      const dto = await this.blockactivityservice.GetBlockactivity(this.studid, GenEnum.ComplainerType.Student);

      if (dto && dto.Data) {
        let blockactivitydata = dto.Data;
        this.localStorage.set("blkactivity", JSON.stringify(blockactivitydata));
      }

      this.localStorage.set("selectedEntity", JSON.stringify(this.studentService.ChildList[0].entityid));

      let studinfo = { "Courseid": this.studentService.ChildList[0].courseid, "Sectionid": this.studentService.ChildList[0].sectionid, "Id": this.studentService.ChildList[0].Id, "entitystxt": this.studentService.ChildList[0].OrgLegalentity.stxt };
      this.localStorage.set("stdinfo", JSON.stringify(studinfo));

      this.navigate("main");
    }
    else {
      if (this.studentService.ChildList && this.studentService.ChildList.length && this.studentService.ChildList.length > 0) {
        let childlistinfo = this.studentService.ChildList;
        this.studentchildlist = true
        childlistinfo.forEach(e => {
          e.studimg = this.imageSource + e.filepath

        });
      }
      else {
        this.studentchildlist = false
      }
    }
    this.loader.stopLoading();
  }

  async currentguardian(Id, id) {

    let guardian = await this.guardianService.getCurrentGuardian(Id);

    if (guardian && guardian.Data) {

      let guardiandata = guardian.Data;
      this.guardianname = guardiandata.name ? guardiandata.name : "-";
      this.guardianlastname = guardiandata.lastname ? guardiandata.lastname : "-";
      this.guardiancontactno = guardiandata.contactno ? guardiandata.contactno : "-";
      this.guardianaddress = guardiandata.address ? guardiandata.address : "-";
      this.guardianemail = guardiandata.email ? guardiandata.email : "-";

      if (guardian.Data.imageid) {
        let imageid = guardian.Data.imageid
        let guardianimageid = await this.imageService.getImage(imageid);
        if (guardianimageid) {
          this.guardianimage = this.imageSource + guardianimageid.Data.filename;
          this.localStorage.set('guardianimage', this.guardianimage);
        }
      }
      else {
      }
    }
    else {
      this.showErrors(guardian.Errors)
    }

  }

  async getstud(item) {
    
    if (item) {

      this.loader.startLoading();
      this.localStorage.set("Studentid", item.Id);

      const dto = await this.blockactivityservice.GetBlockactivity(item.Id, GenEnum.ComplainerType.Student);
      
      if (dto && dto.Data) {
        let blockactivitydata = dto.Data;
        this.localStorage.set("blkactivity", JSON.stringify(blockactivitydata));
      }

      this.localStorage.set("selectedEntity", JSON.stringify(item.entityid));
      let studinfo = { "Courseid": item.courseid, "Sectionid": item.sectionid, "Id": item.Id, "entitystxt": item.OrgLegalentity.stxt };
      
      this.localStorage.set("stdinfo", JSON.stringify(studinfo));
      
      this.navigate("main");
      this.loader.stopLoading();
    }

  }
  async logoutbtn() {
    this.navigate("login");
  }

}



// WEBPACK FOOTER //
// ./src/app/shell/Parent-Portal/childs/childs.component.ts